import * as React from "react"
import { useEffect, useState } from "react"

import load from "../../img/ocs-loading-indicator.png"

export interface LoadingPanelProps {
  loadingTxt: string
  loadingSubTxt?: string
  visible: boolean
  overlay?: boolean
  disableTimeout?: boolean
  callback?: () => void
}

export const LoadingPanel: React.FunctionComponent<LoadingPanelProps> = ({
  loadingTxt,
  loadingSubTxt,
  visible,
  overlay,
  disableTimeout,
  callback
}) => {
  const [show, setShow] = useState<boolean>(false)
  const [timeoutIsDone, setTimeoutIsDone] = useState<boolean>(false)

  useEffect(() => {
    if (disableTimeout) {
      setShow(visible)
      if (!visible) {
        callback && callback()
      }
    } else {
      if (visible && !timeoutIsDone) {
        setShow(true)
        setTimeout(() => {
          setTimeoutIsDone(true)
        }, 2000)
      }

      if (!visible && timeoutIsDone) {
        setShow(false)
        setTimeoutIsDone(false)
        callback && callback()
      }
    }
  }, [visible, timeoutIsDone, disableTimeout, callback])

  return (
    show && (
      <div
        className={
          "d-flex justify-content-center align-items-center" +
          (overlay ? " ocs-overlay " : "")
        }
      >
        <div className="ocs-loading-container d-flex flex-column align-items-center">
          <img src={load} alt="loading indicator" />
          <p>{loadingTxt}</p>
          {loadingSubTxt && <p>{loadingSubTxt}</p>}
        </div>
      </div>
    )
  )
}

LoadingPanel.defaultProps = {
  overlay: true
}
